import React from 'react';
import { Checkbox as SemCheckbox, Radio } from 'semantic-ui-react';
import { isMobile, isTabletOrLess } from 'utils/isMobile';

const errorStyle = {
	marginBottom: 10,
	color: '#dc0000',
	fontSize: '0.7em',
};

const styles = {
	container: {
		height: 30,
		display: 'flex',
		alignItems: 'center',
		flex: 1,
		flexBasis: isMobile() ? '100%' : isTabletOrLess() ? '50%' : '33%',
	},
	label: {
		fontSize: '0.9em',
		marginLeft: 10,
	},
	radioLabel: {
		fontSize: '0.8em',
		marginTop: 5,
		marginLeft: 2,
	},
};

// Checkbox input
export const CheckboxToggle = ({
	field: { name, value, onChange, onBlur },
	form: { errors, touched, setFieldValue },
	id,
	label,
	className,
	disabled,
	...props
}) => {
	return (
		<div style={{ ...styles.container, ...props.style }}>
			<div style={styles.label}>{props.customlabel}</div>

			<SemCheckbox
				toggle
				name={name}
				type='checkbox'
				id={id}
				checked={value}
				onChange={onChange}
				onBlur={onBlur}
				{...props}
				style={{ float: 'right' }}
				disabled={disabled}
			/>

			{touched[name] && errors[name] && (
				<div style={errorStyle}>{errors[name]}</div>
			)}
		</div>
	);
};

// Checkbox input
export const Checkbox = ({
	field: { name, value, onChange, onBlur },
	form: { errors, touched, setFieldValue },
	id,
	label,
	className,
	disabled,
	...props
}) => {
	//Prevent error
	delete props['prevalidfolders'];

	return (
		<div style={{ ...styles.container, ...props.style }}>
			<SemCheckbox
				name={name}
				type='checkbox'
				id={id}
				checked={value}
				onChange={onChange}
				onBlur={(e) => {
					onBlur();
				}}
				disabled={disabled}
				{...props}
			/>

			<span style={styles.label}>{props.customlabel}</span>

			{touched[name] && errors[name] && (
				<div style={errorStyle}>{errors[name]}</div>
			)}
		</div>
	);
};

// Radio input
export const RadioButton = ({
	field: { name, value, onChange, onBlur },
	id,
	label,
	className,
	setFieldValue,
	values,
	disabled,
	...props
}) => {
	return (
		<div>
			<Radio
				label={props.customlabel}
				type='radio'
				checked={values[id] === name}
				onChange={() => {
					values[id] = name;
					onBlur();
				}}
				onBlur={onBlur}
				disabled={disabled}
				{...props}
			/>
		</div>
	);
};
